// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubmitButton_wrapper__OMN5i","button":"SubmitButton_button__sogV_"};